import React from 'react'

export default function ErrorComponent(props) {
    return (
        <div className="alert-danger p-2 my-2" style={{    background: '#feddd7', color: '#666', borderRadius: '.125rem', border: '1px solid #f8b5b4' }}>
           <p className="mb-0">{!props.message? 'Sorry! Some Error Occured, Please try again.': props.message}</p>
        </div>
    )
}
